<template>
  <div>
    <router-link
      :to="{ path: 'search', query: { id } }"
    >
      <gm-search
        disabled
        :placeholder="$t('search_placeholder')"
      ></gm-search>
    </router-link>
    <div>
      <div class="hot-problem">
        <span>
          <span class="icon-hot">
            <span class="path1"></span>
            <span class="path2"></span>
          </span>
          <span>{{ $t('hotpot_issues') }}</span>
        </span>
        <router-link
          :to="{ path: 'list', query: { id, name: $t('hotpot_issues'), all: true } }"
        >
          <span class="all">{{ $t('all') }}</span>
        </router-link>
      </div>
      <gm-list :list="problems"></gm-list>
    </div>
    <div class="group">
      <div class="port" v-if="service.length">
        <div
          :key="i"
          :class="{ on: i === current }"
          v-for="(v, i) in service"
          @click="switchTab(i)"
        >
          {{v.name}}
        </div>
      </div>
      <gm-list
        v-if="service[current]"
        :list="service[current].children"
        :showArticle="false"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import GmSearch from '@/components/Search'
import GmList from '../components/List'

export default {
  name: 'service',
  components: {
    GmSearch,
    GmList,
  },
  data() {
    return {
      id: '',
      current: 0
    }
  },
  activated() {
    const id = (this.$route.query.id || '').toString()
    if (this.id !== id) {
      this.id = id
      this.$store.dispatch('requestData', {
        method: 'service',
        payload: {}
      })
      this.$store.dispatch('requestData', {
        method: 'hotList',
        payload: []
      })
      this.$store.dispatch('requestServiceList', { id })
      this.$store.dispatch('requestSomeHotList', { id })
    }
  },
  computed: {
    ...mapGetters({
      problems: 'getSomeHotList',
      service: 'getServiceList'
    })
  },
  methods: {
    switchTab (index) {
      this.current = index
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/help-center/views/ServiceView.vue